import { render, staticRenderFns } from "./groupDetails.vue?vue&type=template&id=e6569ee0&scoped=true"
import script from "./groupDetails.vue?vue&type=script&lang=js"
export * from "./groupDetails.vue?vue&type=script&lang=js"
import style0 from "./groupDetails.vue?vue&type=style&index=0&id=e6569ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6569ee0",
  null
  
)

export default component.exports